<template>
  <div>
    <div v-if="imageSrc" class="resource-image-container" @click="triggerClick" @keydown="triggerClick">
      <img
        :src="imageSrc"
        :alt="alt"
        :class="[
          {
            thumbnail: isThumbnail,
            'preview-thumbnail': previewThumbnail,
            'big-picture': bigPicture,
            small: small,
          },
        ]"
      />
      <div v-if="previewThumbnail" :class="['middle', { 'mx-auto': centered }]">
        <v-icon x-large color="blue">mdi-magnify-plus-outline</v-icon>
      </div>
    </div>
    <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
  </div>
</template>

<script>
import mediaProvider from '@/data-provider/mediaProvider';

export default {
  props: {
    image: {
      type: [File, Array],
      default: null,
    },
    resourceId: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    isThumbnail: {
      type: Boolean,
      default: false,
    },
    previewThumbnail: {
      type: Boolean,
      default: false,
    },
    bigPicture: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageSrc: null,
    };
  },
  mounted() {
    if (!this.image || this.image.length === 0) {
      mediaProvider.getMediaDownloadUrl(this.resourceId).then((url) => {
        this.imageSrc = url;
      });
      return;
    }

    const image = Array.isArray(this.image) ? this.image[0] : this.image;
    this.imageSrc = URL.createObjectURL(image);
  },
  methods: {
    triggerClick() {
      this.$emit('click');
    },
  },
};
</script>

<style>
.thumbnail {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.preview-thumbnail {
  opacity: 1;
  display: block;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.small {
  max-height: 150px;
  object-fit: contain;
}

.big-picture {
  display: block;
  margin: auto;
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: contain;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 0;
  text-align: center;
}

img:not(.thumbnail) + .middle {
  width: 50%;
  height: 50%;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.resource-image-container {
  position: relative;
}

.resource-image-container:hover .preview-thumbnail {
  border-style: dashed;
  cursor: pointer;
  opacity: 0.3;
}

.resource-image-container:hover .middle {
  cursor: pointer;
  opacity: 1;
}
</style>
